import './App.css';
import FetchWordPressCats from "./hooks/FetchWordPressCats";
import FetchWordPressProps from "./hooks/FetchWordPressProps";
import useHoverCoordinates from "./hooks/useHoverCoordinates";
import Types from './Types';
import Properties from './Properties';
import Map from './Map';

const App = () => {

	const { cats, catsLoading, catsError } = FetchWordPressCats();
	const { props, loading, error, selected, handleFilter } = FetchWordPressProps();
	const { hoverCoords, handleHover, handleHoverOut } = useHoverCoordinates();

	return (
		<div className="App container-fluid">
			<div className="row border-btm">
				<div className="col-md-12">
					<Types
						cats={cats}
						selected={selected}
						handleFilter={handleFilter}
						loading={catsLoading}
						error={catsError}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-md-6">
					<Properties props={props} loading={loading} error={error} selected={selected} handleHover={handleHover} handleHoverOut={handleHoverOut} />
				</div>
				<div className="col-md-6">
					<Map props={props} loading={loading} error={error} selected={selected} hoverCoords={hoverCoords} />
				</div>
			</div>
		</div>
	);
}

export default App;
